/** 플랫폼 전역 공지·약관 등: 워크스페이스와 무관한 콘텐츠 식별(로컬 확인 저장 등) */
export const PLATFORM_CONTENT_SCOPE_KEY = '__platform__';
